import { useMemo } from "react";
import { useUrlSearch } from "@/shared/hooks/useUrlSearch";
import { useLogsQuery } from "../utils/queries";
import { searchValues } from "../utils/options";
import { tableColumns } from "../components/TableOptions";

export const useLogsPage = () => {
  const {
    appliedValues,
    draftValues,
    updateDraft,
    applySearch,
    resetSearch,
    page,
    size,
    setPage,
    setSize,
    showFilters,
    setShowFilters,
  } = useUrlSearch({
    defaultValues: searchValues,
  });

  // Query with URL-based params
  const queryParams = useMemo(
    () => ({ page, perSize: size, search: appliedValues }),
    [page, size, appliedValues],
  );

  const {
    data: queryData,
    isLoading,
    error,
    refetch,
  } = useLogsQuery(queryParams);

  const data = queryData?.data || [];
  const totalItems = queryData?.totalItems || 0;

  // Columns
  const columns = useMemo(() => tableColumns, []);

  return {
    // Data
    data,
    columns,
    isLoading,
    error,
    totalItems,
    // Search (for compatibility with existing components)
    search: { show: showFilters, values: draftValues },
    updateSearch: (updates) => {
      if (updates.show !== undefined) setShowFilters(updates.show);
      if (updates.values) {
        Object.entries(updates.values).forEach(([key, value]) => {
          updateDraft(key, value);
        });
      }
    },
    applySearch,
    resetSearch,
    // Pagination (for compatibility with existing components)
    pg: { page, size },
    updatePg: (updates) => {
      if (updates.page !== undefined) setPage(updates.page);
      if (updates.size !== undefined) setSize(updates.size);
    },
    // Actions
    refetch,
  };
};
